export default function formatTeamMembers(teamMembers) {
  return teamMembers?.map(({ displayName, primary, userId }) => ({
    value: userId,
    text: `@${displayName}`,
    primary,
    displayName,
  }));
}
